module.exports = __webpack_public_path__ + "img/error.ef85133b.svg";